import { createStore, combineReducers, applyMiddleware } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory, History } from 'history'

import { productsReducer } from './reducers/products'
import { productAliasesReducer } from './reducers/productAliases'
import { uiReducer } from './reducers/ui'
import { productAliasesMiddlewares } from './middleware/productAliases'
import { productsMiddlewares } from './middleware/products'
import { apiMiddlewares } from './middleware/api'
import { uiMiddlewares } from './middleware/ui'
import { batchProductCreatorMiddleware } from './middleware/batchProductCreator'
import { batchProductCreatorReducer } from './reducers/batchProductCreator'
import TrackJSLogger from './middleware/trackJSMiddleware'

export const history = createBrowserHistory()

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    products: productsReducer,
    productAliases: productAliasesReducer,
    ui: uiReducer,
    batchProductCreator: batchProductCreatorReducer,
  })

export type AppState = ReturnType<ReturnType<typeof rootReducer>>

export const configureStore = () => {
  const middlewares = [
    routerMiddleware(history),
    thunkMiddleware,
    TrackJSLogger,
    ...productAliasesMiddlewares,
    ...productsMiddlewares,
    ...apiMiddlewares,
    ...uiMiddlewares,
    ...batchProductCreatorMiddleware,
  ]

  const middleWareEnhancer = applyMiddleware(...middlewares)

  return createStore(rootReducer(history), {}, composeWithDevTools(middleWareEnhancer))
}
